import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-3ad81cf9"), n = n(), _popScopeId(), n);
const _hoisted_1 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "batch-textarea-title"
}, "使用回车换行分割", -1));
import { message } from 'ant-design-vue';
import { watch, ref } from 'vue';
export default /*#__PURE__*/_defineComponent({
  __name: 'BatchModal',
  props: {
    modalVisible: {
      type: Boolean,
      required: true
    },
    initialValue: {
      type: String,
      default: ''
    }
  },
  emits: ['update:modalVisible', 'submitBatchId'],
  setup(__props, {
    emit
  }) {
    const props = __props;
    const ids = ref('');
    // 监听弹框显示状态，当打开时设置初始值
    watch(() => props.modalVisible, newVal => {
      if (newVal && props.initialValue) {
        // 将分号替换为换行符进行回显
        ids.value = props.initialValue.replace(/;/g, '\n');
      }
    });
    const closeModal = () => {
      ids.value = '';
      emit('update:modalVisible', false);
    };
    const submitBatchId = () => {
      if (!ids.value) return message.error('请输入批量添加的DBT订单号/平台订单号');
      emit('submitBatchId', ids.value);
      closeModal();
    };
    return (_ctx, _cache) => {
      const _component_a_textarea = _resolveComponent("a-textarea");
      const _component_a_modal = _resolveComponent("a-modal");
      return _openBlock(), _createBlock(_component_a_modal, {
        class: "batch-modal",
        title: "批量添加",
        centered: "",
        open: __props.modalVisible,
        onCancel: closeModal,
        onOk: submitBatchId,
        width: "588px"
      }, {
        default: _withCtx(() => [_hoisted_1, _createVNode(_component_a_textarea, {
          value: ids.value,
          "onUpdate:value": _cache[0] || (_cache[0] = $event => ids.value = $event),
          class: "batch-textarea",
          placeholder: "请输入"
        }, null, 8, ["value"])]),
        _: 1
      }, 8, ["open"]);
    };
  }
});